import "styles/components/common/floatingLabel.css";

interface FloatingLabel {
  label: string;
  shrink: boolean;
  id: string;
}
const FloatingLabel: React.FC<FloatingLabel> = ({ label, shrink, id }) => {
  return (
    <label htmlFor={id} className={`floatingLabel ${shrink ? "shrink" : ""}`}>
      {label}
    </label>
  );
};

export default FloatingLabel;
